import { asString, loadedDefinedMapWithDefault, asArrayValue, asNumber } from "common/components/component-helpers";
import { LOADING, ActionSource } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import PivotHeader from "../ui/views/pivot-header/pivot-header";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";

export const PivotPickerMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[pivotNamesValue, currentValue, onChangeValue], [, valueProducer]] = useForceValueProducers(
        getValueProducers,
        force,
        ctx
    );
    const { onClick: onChangeCB } = useOnClickFromAction(onChangeValue, ActionSource.PivotPicker, ctx, env);
    if (pivotNamesValue === LOADING || currentValue === LOADING) {
        return env.renderProgress();
    }
    const pivotNames = asArrayValue(pivotNamesValue).map((vp, i) =>
        loadedDefinedMapWithDefault(vp.current, `Pivot ${i + 1}`, asString)
    );
    const currentIndex = asNumber(currentValue);

    // logInfo("currentIndex", currentIndex);

    const onChange = (newIndex: number): void => {
        if (valueProducer === undefined) return;

        valueProducer.set(newIndex);
        if (onChangeCB !== undefined) {
            void onChangeCB(undefined);
        }
    };

    return <PivotHeader renderEnvironment={env} items={pivotNames} onClick={onChange} current={currentIndex} />;
};
